// src/App.js
import React, { useEffect, useState, useCallback } from "react";
import { Container } from "react-bootstrap";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import MapBetaPage from "./pages/MapBetaPage";
import "./index.css";
import PageContent from "./components/PageContent";
import { supabase } from "./supabaseClient";
import PwaInstallBanner from "./PwaInstallBanner";
import HeaderTW from "./components/HeaderTW";
import FooterTW from "./components/FooterTW";


function App() {
  // Egyszerű kliens oldali oldalváltáshoz a PageContent-nek továbbra is átadjuk
  const [currentPage, setCurrentPage] = useState("home");

  // Supabase auth állapot
  const [authLoading, setAuthLoading] = useState(true);
  const [user, setUser] = useState(null);

  // Kezdeti session beolvasás + feliratkozás változásokra
  useEffect(() => {
    let alive = true;

    // 1) jelenlegi session
    supabase.auth.getSession().then(({ data }) => {
      if (!alive) return;
      setUser(data?.session?.user ?? null);
      setAuthLoading(false);
    });

    // 2) változások figyelése (signin/signout/token refresh)
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      if (!alive) return;
      setUser(session?.user ?? null);
    });

    return () => {
      alive = false;
      sub?.subscription?.unsubscribe();
    };
  }, []);

  // (opcionális) kijelentkezés segédfüggvény
  const handleSignOut = useCallback(async () => {
    await supabase.auth.signOut();
    setUser(null);
  }, []);

  if (authLoading) {
    // amíg a session tölt, ne rendereljünk "Belépés" állapotot
    return (
      <Container className="mt-4">
        <div className="text-muted">Bejelentkezés ellenőrzése…</div>
      </Container>
    );
  }

  return (
  <Router>
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <PwaInstallBanner />

      <HeaderTW user={user} onSignOut={handleSignOut} setCurrentPage={setCurrentPage} />

      <div style={{ flex: "1 0 auto" }}>
        <Routes>
          <Route
            path="/"
            element={
              <Container className="mt-4">
                <PageContent
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  user={user}
                  onSignOut={handleSignOut}
                />
              </Container>
            }
          />
          <Route path="/terkep" element={<MapBetaPage hideAdmin />} />
          <Route path="/terkep-beta-93hfs8" element={<MapBetaPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>

      <FooterTW setCurrentPage={setCurrentPage} />
    </div>
  </Router>
);
}

export default App;
